import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import ExpenseAdd from './ExpenseAdd';
import { useAuth } from './AuthContext';

function ExpenseList({ onClose, onExpenseChanged }) {
  const { user } = useAuth();
  const [expenses, setExpenses] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchExpenses = () => {
    setLoading(true);
    fetch(`https://www.irsaliye.bybello.com/backend/api/expenses.php?user_id=${user.id}`)
      .then(res => res.json())
      .then(data => {
        setExpenses(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    if (user && user.id) fetchExpenses();
  }, [user]);

  // ESC ile modal kapama
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        if (onClose) onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const handleDelete = (id) => {
    fetch(`https://www.irsaliye.bybello.com/backend/api/expenses.php?id=${id}`, {
      method: 'DELETE',
    })
      .then(() => {
        fetchExpenses();
        if (onExpenseChanged) onExpenseChanged();
      });
  };

  const handleExpenseAdded = () => {
    setShowAddModal(false);
    fetchExpenses();
    if (onExpenseChanged) onExpenseChanged();
  };

  const handleExportExcel = () => {
    if (!expenses || expenses.length === 0) {
      alert('Aktarılacak harcama yok!');
      return;
    }
    const data = expenses.map(e => ({
      'Tutar': e.amount,
      'Açıklama': e.description,
      'Tarih': e.date
    }));
    const total = expenses.reduce((sum, e) => sum + Number(e.amount), 0);
    data.push({ 'Tutar': total, 'Açıklama': 'Toplam', 'Tarih': '' });
    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet['!cols'] = [ { wch: 12 }, { wch: 30 }, { wch: 14 } ];
    // Başlık satırı kalın
    ['A1','B1','C1'].forEach(cell => { if (worksheet[cell]) worksheet[cell].s = { font: { bold: true } }; });
    // Toplam satırı kalın ve sarı
    const totalRow = data.length + 1;
    if (worksheet[`A${totalRow}`]) worksheet[`A${totalRow}`].s = { font: { bold: true }, fill: { fgColor: { rgb: 'FFF9C4' } } };
    if (worksheet[`B${totalRow}`]) worksheet[`B${totalRow}`].s = { font: { bold: true }, fill: { fgColor: { rgb: 'FFF9C4' } } };
    if (worksheet[`C${totalRow}`]) worksheet[`C${totalRow}`].s = { font: { bold: true }, fill: { fgColor: { rgb: 'FFF9C4' } } };
    // Tutar ve Tarih formatı
    for (let row = 2; row <= data.length + 1; row++) {
      const amountCell = `A${row}`;
      if (worksheet[amountCell]) worksheet[amountCell].z = '₺ #,##0.00';
      const dateCell = `C${row}`;
      if (worksheet[dateCell] && worksheet[dateCell].v) {
        worksheet[dateCell].z = 'yyyy-mm-dd';
        const dateValue = worksheet[dateCell].v;
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
          const [y, m, d] = dateValue.split('-').map(Number);
          worksheet[dateCell].v = new Date(Date.UTC(y, m - 1, d));
          worksheet[dateCell].t = 'd';
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Harcamalar');
    XLSX.writeFile(workbook, `harcamalar_${user.id}.xlsx`);
  };

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2>Harcamalar</h2>
        <div>
          <button className="btn btn-success me-2" onClick={handleExportExcel}>Excele Aktar</button>
          <button className="btn btn-primary" onClick={() => setShowAddModal(true)}>Yeni Harcama Ekle</button>
        </div>
      </div>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Tutar</th>
            <th>Açıklama</th>
            <th>Tarih</th>
            <th>İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {expenses.length === 0 ? (
            <tr><td colSpan="4">Henüz harcama yok.</td></tr>
          ) : (
            expenses.map(e => (
              <tr key={e.id}>
                <td>{Number(e.amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</td>
                <td>{e.description}</td>
                <td>{e.date}</td>
                <td><button className="btn btn-danger btn-sm" onClick={() => handleDelete(e.id)}>Sil</button></td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {showAddModal && <ExpenseAdd onExpenseAdded={handleExpenseAdded} userId={user.id} />}
    </div>
  );
}

export default ExpenseList; 